import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-oa-mkbWinstvrijstelling',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-oa-mkbWinstvrijstelling.component.html',
    styleUrl: './tekst-oa-mkbWinstvrijstelling.component.scss',
})
export class TekstOaMkbWinstvrijstellingComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public mkbWinstvrijstelling = 0;

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year === 2024) {
                this.mkbWinstvrijstelling = 14;
            }
            if (this.year === 2025) {
                this.mkbWinstvrijstelling = 12.7;
            }
        })
    }

}
